<template>
  <div class="flujo-fondos">
    <b-card header= "Saldos Iniciales">
      <b-row>
        <b-col cols="6" xl="6">
          <b-form-group
            label="Bancos"
            label-for="saldoBancos"
            :label-cols="labelCols"
            description="Saldo Inicial de Bancos"
            horizontal>
            <b-form-input 
              id="saldoBancos" 
              :value="saldoBancos | moneda" 
              readonly
              type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Cheques"
            label-for="saldoChequesTerceros"
            :label-cols="labelCols"
            description="Saldo de Cheques de Terceros en Cartera"
            horizontal>
            <b-form-input 
              id="saldoChequesTerceros" 
              :value="saldoChequesTerceros | moneda" 
              readonly
              type="text">
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="T.C."
            label-for="cotizacionDolar"
            :label-cols="labelCols"
            description="Cotización del Dolar"
            horizontal>
            <b-form-input 
              id="cotizacionDolar" 
              :value="cotizacionDolar | moneda" 
              readonly
              type="text">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Flujo de Fondos">
                <!-- responsive="sm"  -->
                <!-- hover -->
            <b-table 
                class="registro flujo"
                responsive
                :no-border-collapse="true"
                :busy="tableBusy"
                :items="flujoFondos" 
                :fields="flujoFondosFields"
                @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
            </b-table>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <app-deuda-clientes v-if="consultarDeudaClientes" 
      :fechaResultados="fechaResultados"/>

    <app-cheques-terceros v-if="consultarChequesTerceros" 
      :fechaResultados="fechaResultados"/>

    <app-deuda-proveedores v-if="consultarDeudaProveedores" 
      :fechaResultados="fechaResultados"/>

    <app-cheques-propios v-if="consultarChequesPropios" 
      :fechaResultados="fechaResultados"/>

    <app-tarjetas-resumenes v-if="consultarTarjetasResumenes" 
      :fechaResultados="fechaResultados"/>

    <app-bancos-ingresos v-if="consultarBancosIngresos" 
      :fechaResultados="fechaResultados"/>

    <app-bancos-egresos v-if="consultarBancosEgresos" 
      :fechaResultados="fechaResultados"/>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          <b-dropdown-item
              @click.stop="exportXls">
            <i class="fa fa-file-excel-o"></i>Exportar Flujo de Fondos</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import DeudaClientes from './DeudaClientes.vue';
import ChequesTerceros from './ChequesTerceros.vue';
import DeudaProveedores from './DeudaProveedores.vue';
import ChequesPropios from './ChequesPropios.vue';
import TarjetasResumenes from './TarjetasResumenes.vue';
import BancosIngresos from './BancosMovimientos.vue';
import BancosEgresos from './BancosMovimientos.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';
import moment from 'moment';

const { mapFields } = createHelpers({
  getterType: 'flujoFondos/getField',
  mutationType: 'flujoFondos/updateField',
});

export default {
  name: 'FlujoFondos',
  components: {
    appDeudaClientes: DeudaClientes,
    appChequesTerceros: ChequesTerceros,
    appDeudaProveedores: DeudaProveedores,
    appChequesPropios: ChequesPropios,
    appTarjetasResumenes: TarjetasResumenes,
    appBancosIngresos: BancosIngresos,
    appBancosEgresos: BancosEgresos,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal 
  ],
  data: () => {
    return {
      tableBusy: false,
      labelCols: 2,

      fechaResultados: '',
      consultarDeudaClientes: false,
      consultarChequesTerceros: false,
      consultarDeudaProveedores: false,
      consultarChequesPropios: false,
      consultarTarjetasResumenes: false,
      consultarBancosIngresos: false,
      consultarBancosEgresos: false,
    }
  },
  computed: {
    ...mapFields([
      'fechaDesde',
      'fechaHasta',
      'saldoBancos',
      'saldoChequesTerceros',
      'cotizacionDolar',
      'flujoFondos',
      'flujoFondosFields',
      'flujoFondosForExport',
      'flujoFondosCols'
    ]),
  },
  created() {
    this.getFlujoFondos();
  },  
  methods: {
    getFlujoFondos() {
      this.tableBusy = true;
      this.$store.dispatch('flujoFondos/getFlujoFondos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    inicializarConsultas() {
      this.consultarDeudaClientes = false;
      this.consultarChequesTerceros = false;
      this.consultarDeudaProveedores = false;
      this.consultarChequesPropios = false;
      this.consultarTarjetasResumenes = false;
      this.consultarBancosIngresos = false;
      this.consultarBancosEgresos = false;
    },
    consultar(item, index, event) {
      let row = index;
      let col = 0;
      let consultarResultados = true;

      if (event) {
        if (event.srcElement) {
          col = event.srcElement.ariaColIndex | 0;
        }
        if (event.target) {
          if (event.target.firstChild) {
            if (event.target.firstChild.nodeValue) {
              if (this.$options.filters.moneda(0).trim() == event.target.firstChild.nodeValue.trim()) {
                consultarResultados = false;
              }
            }
          }
        }
      }

      if (col != 0 & consultarResultados) {
        let column = this.flujoFondosCols.find(t => t.col == col);

        if (column) {
          this.fechaResultados = moment(column.fechaDesde).format('YYYY-MM-DD');
          
          let params = {
            fechaDesde: column.col == 2? '1900-01-01' : column.fechaDesde,
            fechaHasta: column.fechaHasta
          }

          switch (row) {
            case 1: // Bancos Ingresos
              params.fechaDesde = column.fechaDesde;
              this.$store.dispatch('flujoFondos/getBancosIngresos', params)
                .then(() => {
                  this.inicializarConsultas();
                  this.consultarBancosIngresos = true
                })
                .catch(error => this.showErrorMsj(error));
              break;

            case 2: // Cheques terceros
              this.$store.dispatch('flujoFondos/getChequesTerceros', params)
                .then(() => {
                  this.inicializarConsultas();
                  this.consultarChequesTerceros = true
                })
                .catch(error => this.showErrorMsj(error));
              break;

            case 3: // Consultar clientes
              this.$store.dispatch('flujoFondos/getDeudaClientes', params)
                .then(() => {
                  this.inicializarConsultas();
                  this.consultarDeudaClientes = true
                })
                .catch(error => this.showErrorMsj(error));
              break;

            case 5: // Bancos Egresos
              params.fechaDesde = column.fechaDesde;
              this.$store.dispatch('flujoFondos/getBancosEgresos', params)
                .then(() => {
                  this.inicializarConsultas();
                  this.consultarBancosEgresos = true
                })
                .catch(error => this.showErrorMsj(error));
              break;

            case 6: // Cheques propios
              this.$store.dispatch('flujoFondos/getChequesPropios', params)
                .then(() => {
                  this.inicializarConsultas();
                  this.consultarChequesPropios = true
                })
                .catch(error => this.showErrorMsj(error));
              break;

            case 7: // Tarjetas Resumenes
              this.$store.dispatch('flujoFondos/getTarjetasResumenes', params)
                .then(() => {
                  this.inicializarConsultas();
                  this.consultarTarjetasResumenes = true
                })
                .catch(error => this.showErrorMsj(error));
              break;

            case 11: // Consultar proveedores
              this.$store.dispatch('flujoFondos/getDeudaProveedores', params)
                .then(() => {
                  this.inicializarConsultas();
                  this.consultarDeudaProveedores = true
                })
                .catch(error => this.showErrorMsj(error));
              break;
              
            default:
              this.inicializarConsultas();
              break;
          }
        }
      }
    },
    exportXls() {
      this.exportXLSFlujoFondos(this.flujoFondosForExport, this.flujoFondosFields);
    }
  }
}
</script>

<style>
  .flujo-fondos .titles div {
    width: 120px !important;
  }
  .flujo-fondos .registro.flujo table th,
  .flujo-fondos .registro.flujo table td {
    border-right: 1px solid rgba(200, 206, 211, 0.3);
  }
  .flujo-fondos .registro.flujo table th div {
    width: 110px;
  }
  .flujo-fondos .registro.flujo table th div {
    width: 110px;
  }
  .flujo-fondos .registro.flujo table th,
  .flujo-fondos .registro.flujo table td {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .flujo-fondos .registro.flujo tbody tr td.totales-semanales,
  .flujo-fondos .registro.flujo thead tr th.totales-semanales,
  .flujo-fondos .registro.flujo tbody tr td.totales-mensuales,
  .flujo-fondos .registro.flujo thead tr th.totales-mensuales {
    /* color: blue !important; */
    background-color: #f5f5f5 !important;
  }

  .flujo-fondos .registro.flujo tbody > tr:nth-child(1),
  .flujo-fondos .registro.flujo tbody > tr:nth-child(1) th,
  .flujo-fondos .registro.flujo table tbody > tr:nth-child(1) td.gray {
    color: blue !important;
    background-color: #f5f5f5 !important;
  }
  .flujo-fondos .registro.flujo tbody > tr:nth-child(5),
  .flujo-fondos .registro.flujo tbody > tr:nth-child(5) th,
  .flujo-fondos .registro.flujo table tbody > tr:nth-child(5) td.gray {
    color: blue !important;
    background-color: #f5f5f5 !important;
  }
  .flujo-fondos .registro.flujo tbody > tr:nth-child(13),
  .flujo-fondos .registro.flujo tbody > tr:nth-child(13) th,
  .flujo-fondos .registro.flujo table tbody > tr:nth-child(13) td.gray {
    color: red !important;
    background-color: #f5f5f5 !important;
  }
  .flujo-fondos .registro.flujo tbody > tr:nth-child(14),
  .flujo-fondos .registro.flujo tbody > tr:nth-child(14) th,
  .flujo-fondos .registro.flujo table tbody > tr:nth-child(14) td.gray {
    color: blue !important;
    background-color: #f5f5f5 !important;
  }
</style>
